export const getSubApp = (pathname: string) => {
    if (pathname.includes('/poi/')) {
        return 'points-of-interest';
    }
    return 'things-to-do';
};
